import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppFloatingButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER || '+917073339922';
  const message = encodeURIComponent("Hi, I'm interested in your FIBC products");
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      data-testid="whatsapp-floating-button"
    >
      <div className="flex items-center space-x-2">
        {/* Expandable Label */}
        <div
          className={`bg-green-500 text-white px-4 py-2 rounded-full shadow-lg font-medium text-sm transition-all duration-200 ${
            isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 pointer-events-none'
          }`}
        >
          WhatsApp us
        </div>
        
        {/* Button */}
        <div className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-110">
          <MessageCircle className="h-6 w-6" />
        </div>
      </div>
    </a>
  );
};

export default WhatsAppFloatingButton;
